import { Component, Input, OnInit, Optional } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RiskService } from '../../../services/riskService';

@Component({
    selector: 'risk-breakdown',
    templateUrl: './risk-breakdown.component.html',
    standalone: false
})
export class RiskBreakdownComponent implements OnInit {
  @Input() year: string;
  @Input() sector: string;
  @Input() match: string;
  @Input() companyName: string;
  @Input() indicatorId: string;
  @Input() indicatorName: string;

  columns: Array<any>;
  metaInfo: string[];
  breakdown: any[] = [];
  totalScore: number = 0;
  loading = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private riskService: RiskService,
    @Optional() public activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
    this.columns = this.riskService.getColumnsBreakdown();
    this.metaInfo = this.riskService.getMetaBreakdownInfo();

    if (this.activeModal) {
      if (this.match && this.year && this.sector) {
        this.loadBreakdown();
      }
      return;
    }

    this.route.queryParams.subscribe(params => {
      this.match = params['match'];
      this.year = params['year'];
      this.sector = params['sector'];
      this.companyName = params['companyName'];
      this.indicatorId = params['indicatorId'];
      this.indicatorName = params['indicatorName'];

      if (this.match && this.year && this.sector) {
        this.loadBreakdown();
      }
    });
  }

  loadBreakdown() {
    this.loading = true;
    this.riskService.getBreakdown(this.year, this.sector, this.match).subscribe(data => {
      this.breakdown = data || [];
      this.totalScore = this.breakdown.reduce((sum, row) => sum + (row.contribution || 0), 0);
      this.loading = false;
    }, () => {
      this.loading = false;
    });
  }

  bandLabel(band: number): string {
    const labels = { 1: 'R1 (low)', 2: 'R2 (medium)', 3: 'R3 (high)' };
    return labels[band] || String(band);
  }

  goBack() {
    if (this.indicatorId) {
      this.router.navigate(['/indicator/risk-scores'], {
        queryParams: { indicatorId: this.indicatorId, indicatorName: this.indicatorName, year: this.year }
      });
    } else {
      this.router.navigate(['/indicator/risk-results']);
    }
  }
}
